import { keyframes } from 'styled-components';

export * from './highlight-new-content';

export const fadeInKeyframes = keyframes`
from { opacity: 0; }
to { opacity: 1; }
`;
